export const fetchReservationById = async (id_reservation) => {

    const token = localStorage.getItem('token'); // Get token from localStorage
    const apiUrl = process.env.REACT_APP_API_URL;

    
    const response = await fetch(`${apiUrl}/api/edit/reservation/${id_reservation}`, { 
        headers: {
            'Authorization': `Bearer ${token}`,
        },
    });

    if (!response.ok) {
        throw new Error('Failed to update invoice');
    }

    const data = await response.json();

    console.log("data",data);

    return data;
};